module.exports = __webpack_public_path__ + "static/img/successfulTran.78ce68a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/successfulTran.svg
// module id = PLqz
// module chunks = 1